import { z } from 'zod'

import { processEmbedded } from './lib/processEmbedded'
import { processOptionalString } from './lib/processOptionalString'

export const rootSearchSchema = z.object({
  org: processOptionalString,
  bypassFlow: z.boolean().optional().catch(undefined),
  accountToken: processOptionalString,
  allowExit: z.boolean().optional().catch(undefined),
  bypassCard: z.boolean().optional().catch(undefined),
  failKycInquiry: z.boolean().optional().catch(undefined),
  callbackUrl: processOptionalString,
  emailAddress: processOptionalString,
  embedded: processEmbedded,
  emp: processOptionalString,
  firstName: processOptionalString,
  instance: processOptionalString,
  kycReferenceId: processOptionalString,
  lastName: processOptionalString,
  phoneNumber: processOptionalString,
})
